import React, { FC } from 'react';
import { View } from 'react-native';

interface Props {
  borderColor: string;
  backgroundColor: string;
}

const ShiftedBox: FC<Props> = ({ borderColor, backgroundColor, children }) => {
  return (
    <View>
      <View
        style={{
          backgroundColor: borderColor,
          bottom: -3,
          position: 'absolute',
          height: '100%',
          left: -3,
          width: '100%'
        }}
      />
      <View
        style={{
          backgroundColor,
          borderColor,
          borderWidth: 2,
          padding: 16
        }}
      >
        {children}
      </View>
    </View>
  );
};

export default ShiftedBox;
